import { render, staticRenderFns } from "./ExercismKindergartenGarden.vue?vue&type=template&id=a90fdeea&"
import script from "./ExercismKindergartenGarden.vue?vue&type=script&lang=js&"
export * from "./ExercismKindergartenGarden.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports